import { serviceUrl } from "@/utils/request.js"
import request from "@/utils/request"

//上传图片地址（正式服务器）
export const uploadUrl = serviceUrl + "/Anno.Plugs.DevArchive/FileUpload/UploadFile"

//上传XML文件地址（正式服务器）
export const uploadXMLUrl = serviceUrl + "/Anno.Plugs.Files/FileUpload/UploadXmlFile"

//上传文件地址（正式服务器）
export const UploadUpgradeFile = "https://tjtf.cshdjn.com/AnnoApi/Anno.Plugs.DevArchive/FileUpload/UploadUpgradeFile"
